<template>
  <div>
    <Dialog
      :header="header"
      :visible.sync="displayModal"
      :style="{ width: '350px' }"
      :modal="true"
      :contentStyle="{ overflow: 'visible' }"
      @hide="notConfirmed"
    >
      <div class="confirmation-content">
        <div class="grid">
          <div class="col-12" v-if="errores">
            <Errors v-show="this.errores.length > 0" :errors="this.errores" />
          </div>

          <div class="col-1">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
          </div>

          <div class="col-10">
            <span
              >{{ mensajePre }}<b>{{ mensajeNegrita }}</b
              >{{ mensajePost }}</span
            >
          </div>

          <div class="col-1" />
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('common.yes')"
          icon="pi pi-check"
          @click="confirmed()"
          autofocus
        />
        <Button
          :label="$t('common.no')"
          icon="pi pi-times"
          @click="notConfirmed()"
          class="p-button-secondary"
        />
      </template>
    </Dialog>
  </div>
</template>


<script>
import Errors from "@/components/utilidades/Errors.vue";

export default {
  name: "Confirmacion",
  components: {
    Errors: Errors,
  },
  props: [
    "header",
    "mensajePre",
    "mensajeNegrita",
    "mensajePost",
    "errores",
    "displayConfirmation",
  ],
  data() {
    return {
      displayModal: this.displayConfirmation,
    };
  },
  methods: {
    resetValues() {
      this.displayModal = false;
      this.errors = [];
    },
    confirmed() {
      this.resetValues();
      this.$emit("confirmed");
    },
    notConfirmed() {
      this.resetValues();
      this.$emit("not-confirmed");
    },
  },
};
</script>


<style lang="scss" scoped>
</style>